import React, { useState } from 'react';
import { useAdmin } from '../../context/AdminContext';
import { useUser } from '../../context/UserContext';
import TextureForm from './TextureForm';
import '../admin/AdminComponents.css';

const TexturesManagement = () => {
  const { textures, deleteTexture } = useAdmin();
  const { hasPermission } = useUser();
  const [editingTexture, setEditingTexture] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const handleEdit = (texture) => {
    setEditingTexture(texture);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this texture? This will remove it from all products that use it.')) {
      try {
        await deleteTexture(id);
      } catch (error) {
        alert(error.message || 'Failed to delete texture');
      }
    }
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingTexture(null);
  };

  return (
    <div className="admin-section">
      <div className="admin-section-header">
        <h2 className="admin-section-title">Textures Management</h2>
        <div className="admin-section-actions">
          {hasPermission('products.edit') && (
            <button
              className="admin-button primary"
              onClick={() => {
                setEditingTexture(null);
                setShowForm(true);
              }}
            >
              Add Texture
            </button>
          )}
        </div>
      </div>
      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Color</th>
              <th>Preview</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {textures.map((texture) => (
              <tr key={texture.id}>
                <td>{texture.id}</td>
                <td>{texture.name}</td>
                <td>{texture.color}</td>
                <td>
                  <div
                    style={{
                      width: '40px',
                      height: '40px',
                      backgroundColor: texture.color,
                      border: '2px solid var(--border)',
                      borderRadius: '4px'
                    }}
                  />
                </td>
                <td>
                  <div className="admin-table-actions">
                    {hasPermission('products.edit') && (
                      <>
                        <button
                          className="admin-icon-button"
                          onClick={() => handleEdit(texture)}
                          title="Edit"
                        >
                          ✎
                        </button>

                        <button
                          className="admin-icon-button danger"
                          onClick={() => handleDelete(texture.id)}
                          title="Delete"
                        >
                          ×
                        </button>
                      </>

                    )}
                  </div>

                </td>

              </tr>

            ))}
          </tbody>

        </table>

      </div>


      {showForm && (
        <TextureForm
          texture={editingTexture}
          onClose={handleFormClose}
        />

      )}
    </div>

  );
};

export default TexturesManagement;

